import { render, staticRenderFns } from "./FilledDislikeIcon.vue?vue&type=template&id=273a0205"
import script from "./FilledDislikeIcon.vue?vue&type=script&lang=ts"
export * from "./FilledDislikeIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports